import _ from 'lodash';

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'filters' implicitly has an 'any' type.
const getRemainingAttributes = (filters, attributes) => {
  const attributesUsedInFilters = _.map(filters, ({ label }) => label);
  return _.filter(attributes, ({ name }) => !_.includes(attributesUsedInFilters, name));
};

export default getRemainingAttributes;
